// Entry point for the public marketing site (built by the esbuild glob in
// package.json: `app/javascript/*.*`).
//
// Turbo Drive for fast navigation plus a tiny, self-contained Stimulus app for
// the few interactive bits (screenshot lightbox, YouTube facade). Intentionally
// no Shopify App Bridge / Polaris here — this is a public, non-embedded site.
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

import LightboxController from "./marketing/lightbox_controller"
import YoutubeController from "./marketing/youtube_controller"

const application = Application.start()
application.register("lightbox", LightboxController)
application.register("youtube", YoutubeController)
